import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from '../QuarterlyRow.module.css';
import headerStyles from './QtrReinsurersRowHeader.module.css';
import { computeRollingQuarterDates } from '../quarterDateUtils';

interface QtrReinsurersRowHeaderProps {
  readonly helmet: {
    label?: string;
    hasBenchmarkAnalysis?: boolean;
  };
  readonly quarter?: string;
}

export default function QtrReinsurersRowHeader({
  helmet,
  quarter = 'Q3'
}: QtrReinsurersRowHeaderProps) {
  const { showBenchmark, year } = useContext(AppContext);

  const dateHeaders = computeRollingQuarterDates(year, quarter, 5);

  return (
    <div
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}
      data-testid="qtr-reinsurers-row-header">
      {/* 1: Label */}
      <h5>{helmet.label}</h5>
      {/* 2: Icon */}
      <h5 aria-hidden="true"></h5>
      {/* 3: Chevron */}
      <h5 aria-hidden="true"></h5>
      {/* 4: Benchmark */}
      <h5 className="align-center" aria-hidden={!helmet.hasBenchmarkAnalysis}>
        {helmet.hasBenchmarkAnalysis ? 'Benchmark' : ''}
      </h5>
      {/* Empty placeholder columns (Pct Change, $ Change, Surplus, NAA) */}
      <h5 aria-hidden="true"></h5>
      <h5 aria-hidden="true"></h5>
      <h5 aria-hidden="true"></h5>
      <h5 aria-hidden="true"></h5>
      {/* 5 rolling quarter date columns — first has "Count of New Reinsurers" stacked above */}
      {dateHeaders.map((date, i) => (
        <h5 key={date} className="column_align_right">
          {i === 0 && (
            <span className={headerStyles.countGroupLabel}>Count of New Reinsurers</span>
          )}
          {date}
        </h5>
      ))}
    </div>
  );
}
